import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=07cad364&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cad364",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07cad364')) {
      api.createRecord('07cad364', component.options)
    } else {
      api.reload('07cad364', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=07cad364&scoped=true&", function () {
      api.rerender('07cad364', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4PRIFhd3IBv0r/JS/comp/SearchFilterTokens.vue"
export default component.exports